import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";

export default class CardBookingContainersStore {

    tipoAgenda;

    @observable ISOs;
    @observable tiposMercadoria;
    @observable tiposMercadoriaBloqueado;
    @observable transitoAduaneiroCheck
    @observable ISOsBloqueado;
    @observable atualizaSobremedida;
    @observable armadores;
    @observable clientes;

    constructor(tipoAgenda) {
        this.tipoAgenda = tipoAgenda;
        this.atualizaSobremedida = true;
        this.armadores = []
        this.clientes = []
        this.transitoAduaneiroCheck = false
        this.service = new AgendamentoContainerService();

    };


    carregarArmadores = () => {
        this.service.ArmadoresScod()
            .then(response => {
                this.armadores = response.data;
            }).catch(erro => {
                console.log(erro)
            });
    };

    carregarClientes = (info) => {
        this.service.ClientesScod(info)
            .then(response => {
                this.clientes = response.data;

            }).catch(erro => {
                console.log(erro)
            });
    
    };

    carregarClientesPorId = async (info) => {
        await this.service.ClientesScodPorId(info)
            .then(response => {
                console.log('resposta', response)
                this.clientes = response.data;
                console.log(this.clientes)

            }).catch(erro => {
                console.log(erro)
            });
    };

    carregarClientesPorIdImportador = async (info) => {
        await this.service.ClientesScodPorIdImportador(info)
            .then(response => {
                console.log('resposta', response)
                this.clientes = response.data;
                console.log(this.clientes)

            }).catch(erro => {
                console.log(erro)
            });
    };
}




// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/importacao-entrada-depot/stores/CardContainerFilhoStore.js